import { convertDistance, getDistanceUnit } from '../converters/convert-distance.js';
import { toLocaleString } from '../utilities/to-locale-string.js';
export const formatDistance = (locale, system, distance, options = {}) => {
    const { convert = true, ...localeStringOptions } = options;
    const [input, unit] = convert
        ? convertDistance(locale, system, distance)
        : [distance, getDistanceUnit(system)];
    return toLocaleString(input, locale, {
        unit,
        style: 'unit',
        unitDisplay: 'short',
        roundingMode: 'floor',
        maximumFractionDigits: 1,
        minimumFractionDigits: 1,
        ...localeStringOptions
    });
};
